<template>
    <div>
      <q-toggle
          v-model="project.ssl"
          @input="analyzeDomains"
          :label="sslLabel"
          :disable="sslDeploying || sslOptionChanged"
      />

      <analyze-domain
          v-if="analyzerOpened"
          :project="project"
          :opened="analyzerOpened"
          @process="processUpdate"
          @closed="analyzerOpened = !analyzerOpened"
      />
    </div>
</template>

<script>
import {
  QToggle
} from 'quasar';

import AnalyzeDomain from "../ProjectDomains/AnalyzeDomain";

export default {
  name: "ProjectSsl",
  components: {
    QToggle,
    AnalyzeDomain,
  },

  props: {
    project: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      sslOptionChanged: false,
      sslPollingTimer: false,
      analyzerOpened: false,
      changeSslStatus: null,
    }
  },

  computed: {
    sslDeploying() {
      return ['NEW', 'ASSIGNING', 'ASSIGNING_RETRY', 'REMOVING', 'REMOVE_RETRY'].indexOf(this.project.ssl_deployment_status) !== -1;
    },

    sslDeployError() {
      return ['ASSIGNING_ERROR'].indexOf(this.project.ssl_deployment_status) !== -1;
    },

    sslLabel() {
      return this.sslDeploying || this.sslOptionChanged
        ? (this.project.ssl ? 'Включается...' : 'Выключается...')
        : (this.project.ssl ? 'Включен' : 'Выключен');
    }  
  },

  mounted() {
    if (this.sslDeployError) {
      this.showErrorPopup();
    }
  },

  unmounted() {
    this.stopPolling();
  },

  methods: {
    analyzeDomains(value) {
      if (!this.project.ssl) {
        this.updateProjectSsl(value);
        return;
      }

      this.project.ssl = !this.project.ssl;
      this.analyzerOpened = true;
      this.changeSslStatus = value;
    },

    processUpdate() {
      this.analyzerOpened = false;

      this.updateProjectSsl(this.changeSslStatus);
    },

    updateProjectSsl(value) {
      this.$store.commit('project/setProjectSsl', value);
      this.sslOptionChanged = true;
      this.$emit('statusChange');
      setTimeout(() => {
        this.sslOptionChanged = false;
        this.pollSslDeployStatus();
      }, 20000);
    },

    pollSslDeployStatus() {
      if (!this.sslDeploying || this.sslPollingTimer) {
        return;
      }

      this.sslPollingTimer = setInterval(() => {
        this.$store.dispatch('project/fetchProject').then(() => {
          if (!this.sslDeploying) {
            this.stopPolling();
          }

          if (this.sslDeployError) {
            this.stopPolling();
            this.showErrorPopup();
            this.$store.commit('project/setProjectSsl', !this.project.ssl);
            this.$store.dispatch('project/fetchLogs', this.project.id);
          }
        });
      }, 5000);
    },

    stopPolling() {
      clearInterval(this.sslPollingTimer);
      this.sslPollingTimer = false;
    },

    showErrorPopup() {
      this.$q.dialog({
        title: `Ошибка подключения SSL`,
        message: `Проверьте логи проекта`,
        ok: true
      });
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectSsl/ProjectSsl.vue